import React from "react";
import "./spinner.css";

const Spinner = ({ className = "" }) => (
  <div className={`spinner ${className}`}>
    <div className="spinner__area">
      <span className="spinner__drop"> </span>
      <span className="spinner__drop"> </span>
      <span className="spinner__drop"> </span>
    </div>
  </div>
);

export default Spinner;
